module.exports = " <div class=\"weui_cell weui_cell_switch\"> <div class=\"weui_cell_hd weui_cell_primary\"> <label class=weui_label :style=labelStyle v-html=title></label> <inline-desc v-if=inlineDesc>{{inlineDesc}}</inline-desc> </div> <div class=weui_cell_ft> <input class=weui_switch type=checkbox :disabled=disabled v-model=value /> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/switch/index.vue
// module id = 251
// module chunks = 2